window.Partners = (function () {
    let toggleFilter = (parnerID, elem, PartnersJson) => {
        if (elem.classList.contains("active")) {
            elem.classList.remove("active");
        } else {
            elem.classList.add("active");
        }

        let industry = $(`#${parnerID} .partner-filters .filter.industry.active`);
        if (industry.length == $(`#${parnerID} .partner-filters .filter.industry`).length) {
            industry.toArray().forEach(industrylem => {
                industrylem.classList.remove("active");
            })
        }

        let solution = $(`#${parnerID} .partner-filters .filter.solution.active`);
        if (solution.length == $(`#${parnerID} .partner-filters .filter.solution`).length) {
            solution.toArray().forEach(solutionElem => {
                solutionElem.classList.remove("active");
            })
        }

        filterList(parnerID, PartnersJson);
    }

    let openPartner = (parnerID, partnerElem, PartnersJson) => {
        let partnerModel = $(`#${parnerID} .partner-modal`)[0];

        $(".partner-modal .mpa-wp-controls input").click((event) => {
            Partners.closePartner(parnerID)
        })

        let index = partnerElem.attributes["data-index"].value;
        let id = partnerElem.attributes["data-id"].value;

        let partner = PartnersJson[index];

        if (partner.Id == id) {
            partnerModel.querySelector(".company-title").innerText = partner.Name;
            let Description = b64DecodeUnicode(partner.Description);
            partnerModel.querySelector(".modal-partner-body").innerHTML = Description;

            let url = partnerModel.querySelector(".contact.url a");
            url.innerText = partner.Url.split('?')[0];
            url.href = partner.Url;

            let contactUs = partnerModel.querySelector(".contact.phone a");
            contactUs.innerText = partner.ContactUs;
            contactUs.href = "tel:" + partner.ContactUs;

            let email = partnerModel.querySelector(".contact.email a");
            email.innerText = partner.Email;
            email.href = "mailto:" + partner.Email;

            let solutions = partnerModel.querySelectorAll(".solution-dowdown");

            solutions.forEach(sol => {
                let solution = sol.innerText.trim();

                if (partner.Supports.includes(solution)) {
                    if (!sol.classList.contains("active")) {
                        sol.classList.add("active")
                    }
                } else {
                    if (sol.classList.contains("active")) {
                        sol.classList.remove("active")
                    }
                }
            })
        }

        partnerModel.classList.add("show")
    }

    let closePartner = (parnerID) => {
        let partnerModel = $(`#${parnerID} .partner-modal`)[0];

        partnerModel.classList.add("closing")
        partnerModel.classList.remove("show")

        setTimeout(function () {
            partnerModel.classList.remove("closing")
        }, 500);
    }

    let filterList = (parnerID, PartnersJson) => {
        let partnerList = $(`#${parnerID} .partner-list a`);

        let industry = $(`#${parnerID} .partner-filters .filter.industry.active`).toArray().map(a => a.innerText);
        let solution = $(`#${parnerID} .partner-filters .filter.solution.active`).toArray().map(a => a.innerText);

        for (let i = 0; i < partnerList.length; i++) {
            let partnerElement = partnerList[i];
            let index = partnerElement.attributes["data-index"].value;
            let id = partnerElement.attributes["data-id"].value;

            let partner = PartnersJson[index];

            if (partner.Id == id) {

                let filterindustry = checkTwoArrays(partner.Industry, industry, false);
                let filterSupports = checkTwoArrays(partner.Supports, solution, false);

                if (industry.length != 0 && solution.length != 0) {
                    if (filterindustry && filterSupports) {
                        showPartnerList(partnerElement);
                    } else {
                        hidePartnerList(partnerElement);
                    }
                }
                else if (industry.length != 0 && solution.length == 0) {
                    if (filterindustry) {
                        showPartnerList(partnerElement);
                    } else {
                        hidePartnerList(partnerElement);
                    }
                }
                else if (industry.length == 0 && solution.length != 0) {
                    if (filterSupports) {
                        showPartnerList(partnerElement);
                    } else {
                        hidePartnerList(partnerElement);
                    }
                }
                else {
                    showPartnerList(partnerElement);
                }
            }
        }
    }

    let b64DecodeUnicode = (str) => {
        // Going backwards: from bytestream, to percent-encoding, to original string.
        return decodeURIComponent(atob(str).split('').map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
    }

    let showPartnerList = (partnerElement) => {
        if (partnerElement.classList.contains("hidden")) {
            partnerElement.classList.remove("hidden");
        }
    }

    let hidePartnerList = (partnerElement) => {
        if (!partnerElement.classList.contains("hidden")) {
            partnerElement.classList.add("hidden");
        }
    }

    let checkTwoArrays = (partner, filters, strict = false) => {
        let result = strict ? true && filters.length != 0 : false;
        let result2 = [];

        filters.forEach(element => {
            let res = partner.includes(element);
            result = strict ? result && res : result || res;

            result2.push(res);
        });

        return result;
    }

    return _ = {
        toggleFilter: toggleFilter,
        openPartner: openPartner,
        closePartner: closePartner
    }
})();
